import * as Turbo from '@hotwired/turbo'
import Swal from 'sweetalert2'

Turbo.start()
// 確認ダイアログのカスタマイズ
const newConfirmMethod = (message, formElement) => {
  const text = formElement.getAttribute('data-text')
  Swal.fire({
    title: message || '操作を実行してよろしいですか？',
    html: text || '',
    icon: formElement.getAttribute('data-icon'),
    confirmButtonText: 'はい',
    confirmButtonColor: '#40BF6C',
    cancelButtonText: 'キャンセル',
    showCancelButton: true,
    reverseButtons: true,
    focusCancel: true
  })
    .then((result) => {
      if (result.isConfirmed) {
        formElement.submit()
      }
    })
    .catch((error) => {
      console.log(error)
    })

  return false
}
Turbo.setConfirmMethod(newConfirmMethod)

//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// stimulus
import '../controllers'

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'
